import { WriteRequest } from "~/backendApis/foundation/WriteRequest"
import { ApiClient } from "~/backendApis/foundation/ApiClient"
import { UploadedFileResponse } from "~/backendApis/viewModel/file"

interface Params {
  image: Blob
}

export class UploadLeadingCompanyLogoImageWriteRequest extends WriteRequest<UploadedFileResponse> {
  private readonly endpoint =
    "/file/user_profile_search/leading_company_logo_image/upload"
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public post(): Promise<UploadedFileResponse> {
    const formData = new FormData()
    formData.append("image", this.params.image)

    return this.apiClient.post(
      this.endpoint,
      formData,
      ApiClient.MULTIPART_CUSTOM_HEADER
    )
  }
}
